import { createContext } from 'react';

import type { IKybFormContext } from './helpers';

export const KybFormContext = createContext<IKybFormContext | null>(null);
